// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { EntityBaseDto } from './EntityBaseDto';

// AbilityIntranet.Data.Intranet.QbModels.QbContactBaseDto
export class QbContactBaseDto extends EntityBaseDto {
    public timeCreated: Date = null;
    public timeModified: Date = null;
    public salutation: string = null;
    public firstName: string = null;
    public middleName: string = null;
    public lastName: string = null;
    public fullName: string = null;
    public jobTitle: string = null;
    public notes: string = null;
    public qbPrimary: boolean = false;
}


    



